import { datastageApi } from 'datastage/api';
import { filterCriteria } from 'datastage/utils/filterCriteria';

/**
 * GET /products/readyProducts with the standard READY filter.
 *
 * @param {string|number[]} range - Range string from getItemRange or [start, end]
 * @param {string[]} sort - e.g. ['productId', 'DESC']
 * @returns {Promise<Object>} Normalized page payload; may include `code` on API error
 */
export async function fetchReadyProductsPage(range, sort) {
    const rangeParam = Array.isArray(range) ? `${range[0]}, ${range[1]}` : range;
    return datastageApi.readyProducts(
        filterCriteria({}, '', 'readyProducts'),
        rangeParam,
        sort,
    );
}
